"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var EventAvailable_exports = {};
__export(EventAvailable_exports, {
  default: () => EventAvailable_default
});
module.exports = __toCommonJS(EventAvailable_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M15.8628 11.5573C16.1074 11.7808 16.1245 12.1603 15.9009 12.4049L10.8741 17.9049C10.7613 18.0284 10.6021 18.0991 10.4349 18.1001C10.2677 18.1011 10.1076 18.0323 9.99329 17.9102L8.06203 15.8478C7.83554 15.6059 7.84802 15.2262 8.0899 14.9997C8.33179 14.7732 8.71148 14.7857 8.93797 15.0275L10.4259 16.6166L15.0151 11.5954C15.2387 11.3508 15.6182 11.3337 15.8628 11.5573Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 2.40015C8.33137 2.40015 8.6 2.66878 8.6 3.00015V4.00024H15.4V3.00015C15.4 2.66878 15.6686 2.40015 16 2.40015C16.3314 2.40015 16.6 2.66878 16.6 3.00015V4.00024H19C20.1046 4.00024 21 4.89567 21 6.00024V19.0002C21 20.1048 20.1046 21.0002 19 21.0002H5C3.89543 21.0002 3 20.1048 3 19.0002V6.00024C3 4.89567 3.89543 4.00024 5 4.00024H7.4V3.00015C7.4 2.66878 7.66863 2.40015 8 2.40015ZM7.4 5.00024H5C4.44772 5.00024 4 5.44796 4 6.00024L4 8.00024L20 8.00024V6.00024C20 5.44796 19.5523 5.00024 19 5.00024H16.6V6.00015C16.6 6.33152 16.3314 6.60015 16 6.60015C15.6686 6.60015 15.4 6.33152 15.4 6.00015V5.00024H8.6V6.00015C8.6 6.33152 8.33137 6.60015 8 6.60015C7.66863 6.60015 7.4 6.33152 7.4 6.00015V5.00024ZM4 19.0002V9.00024L20 9.00024V19.0002C20 19.5525 19.5523 20.0002 19 20.0002H5C4.44772 20.0002 4 19.5525 4 19.0002Z",
      fill: "currentColor"
    }
  )
);
const SvgEventAvailable = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var EventAvailable_default = SvgEventAvailable;
